/**
 * 中国省市区JSON数据链接
 * @type {string}
 */
export const ChinaGeoJSONLink =
  "https://static3.yishouapp.com/obs/tools/geo/china.json";

/**
 * 履约规则链接
 */
export const PerformanceRuleLink =
  "https://yb7ao262ru.feishu.cn/docx/L4XQd60XdoSkFuxMIuicyHxsnKh";

/**
 * 商家等级权益链接
 */
export const ShopLevelRightsLink =
  "https://yb7ao262ru.feishu.cn/docx/L5cIdqZFJoFgx3xTM9PcWLkinTb";
